import * as React from "react";

import { Callout, ICalloutProps } from "@blueprintjs/core";
import styled from "~/styled";

const CalloutWrapper = styled(Callout)`
  @media (max-width: 568px) {
    /* 'h4' - for title, 'div' - for description */
    h4.bp3-heading {
      font-size: 16px;
    }

    div {
      font-size: 14px;
    }
  }

  @media (max-width: 375px) {
    /* 'h4' - for title, 'div' - for description */
    h4.bp3-heading {
      font-size: 14px;
    }

    div {
      font-size: 12px;
    }
  }

  @media (max-width: 320px) {
    /* 'h4' - for title, 'div' - for description */
    h4.bp3-heading {
      font-size: 12px;
    }

    div {
      font-size: 10px;
    }
  }
`;

export class StyledCallout extends React.Component<ICalloutProps> {
  public render() {
    return (
      <CalloutWrapper {...this.props}>{this.props.children}</CalloutWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/StyledCallout.tsx